import { render, staticRenderFns } from "./pay_fields.vue?vue&type=template&id=201065e0&scoped=true&"
import script from "./pay_fields.vue?vue&type=script&lang=js&"
export * from "./pay_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201065e0",
  null
  
)

export default component.exports